import { render, staticRenderFns } from "./ModalNewProfile.vue?vue&type=template&id=7c661338&scoped=true&"
import script from "./ModalNewProfile.vue?vue&type=script&lang=ts&"
export * from "./ModalNewProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNewProfile.vue?vue&type=style&index=0&id=7c661338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c661338",
  null
  
)

export default component.exports